<template>
  <v-container
    fluid
    class="fill-height"
  >
    <v-row
      justify="center"
      align="center"
      class="ma-0"
    >
      <processing-evaluate-card
        ref="processing-evaluate-card">
      </processing-evaluate-card>
    </v-row>
  </v-container>
</template>

<script>
  import ProcessingEvaluateCard from "../Evaluate/ProcessingEvaluateCard"

  const _FieldLayer = Symbol.for("_FieldLayer")

  export default {
    name: "FieldCardWrapper",
    components: {ProcessingEvaluateCard},
    props: {
      layer: {
        type: window.L.Polygon,
        required: true
      }
    },
    provide() {
      return {
        [_FieldLayer]: () => this.layer,
      }
    },
  }
</script>

<style scoped>
</style>
